module.exports = __webpack_public_path__ + "static/media/rose.e7e0e3d5.webp";